import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

export default class CarrierSelect extends Component {
	render () {
		const { name, controller, carriers, md, disabled } = this.props;
		const label = (this.props.label) ? this.props.label : _.capitalize(name);

		const { formFieldError } = controller.state;
		const error = formFieldError[name];

		const j = _.random(9999999);
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={!!error} disabled={disabled}>
					<InputLabel htmlFor={`carrier${j}`}>{label}</InputLabel>
					<Select
						value={controller.state[name]}
						onChange={event => controller.onChange(event, name)}
						input={<Input id={`carrier${j}`} />}
					>
						{_.sortBy(carriers, 'name').map((carrier, i) => {
							return (
								<MenuItem key={i} value={carrier.carrierId}>
									{carrier.name}
								</MenuItem>
							);
						})}
					</Select>
					{error && <FormHelperText>{error}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
	}
}

CarrierSelect.propTypes = {
	disabled : PropTypes.bool,
	name: PropTypes.string.isRequired,
	controller: PropTypes.object.isRequired,
	carriers : PropTypes.array.isRequired,
	label : PropTypes.string,
	md : PropTypes.number
};


CarrierSelect.defaultProps =  {
	md : 6
};